import {
  StyleParamType,
  wixColorParam,
  createStylesParams,
} from '@wix/tpa-settings';
import {
  CssColor,
  StyleType,
  wixColor,
} from '@wix/editor-platform-ooi-metadata-resolver';

type IStylesParams = {
  bgColor: StyleParamType.Color;
  borderColor: StyleParamType.Color;
  borderWidth: StyleParamType.Number;
  manageMenuBorderRadius: StyleParamType.Number;
};

export const bgBordersStylesParams = createStylesParams<IStylesParams>({
  bgColor: {
    key: 'backgroundColor',
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  borderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstSystemLine1Color,
        opacity: 0.3,
      },
    },
  },
  borderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  manageMenuBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
});
